import { FC } from 'react';

export const HowItWork: FC = props => {
    return (
        <section className="how-it-work" id="how-it-work">
            <div className="container">
                <div className="hik-top">
                    <h2>How it works</h2>
                    <h5>My wallet</h5>
                </div>
                <div className="hik-bottom">
                    <div className="hik-item">
                        <div className="hik-item-img-wrap">
                            <figure>
                                <img src="/assets/img/make-purchase.svg" />
                            </figure>
                        </div>
                        <div className="hik-item-text-wrap">
                            <h3>Make a Purchase</h3>
                            <p>& Load Your Wallet!</p>
                        </div>
                    </div>
                    <div className="hik-item">
                        <div className="hik-item-img-wrap">
                            <figure>
                                <img src="/assets/img/more-value.svg" />
                            </figure>
                        </div>
                        <div className="hik-item-text-wrap">
                            <h3>Get up to 30% More Value</h3>
                            <p>From Your Purchase!</p>
                        </div>
                    </div>
                    <div className="hik-item">
                        <div className="hik-item-img-wrap">
                            <figure>
                                <img src="/assets/img/play-bonus.svg" />
                            </figure>
                        </div>
                        <div className="hik-item-text-wrap">
                            <h3>Enjoy Your Free Play</h3>
                            <p>Available for use at participating casinos!</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
